import { Box, Grid, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import { Context } from "../../../context/context";
import ImageGalleyV2 from "./ImageGalleyV2";
import { MemoizedVehicleDetailsV2 } from "./VehicleDetailsV2";

const CustomVehicleData = styled(Box)(({ theme }) => ({
  width: "82%",
  margin: "0 auto",
  padding: "36px 0",

  [theme.breakpoints.down("md")]: {
    position: "relative",
    top: "-36px",
    width: "100%",
    paddingBottom: "0px",
  },
}));
const LeadCaptureMainV2 = ({ vehicleData }) => {
  const state = useContext(Context);
  let location =
    state?.selectedState === "India" ? "Others" : state?.selectedState;

  const productList = vehicleData?.ProductImages;
  const [productType, setProductType] = useState(productList[0]);

  const handleThumbnailClick = (dummyBodyObj) => {
    setProductType(
      productList.find((item) => item?.type === dummyBodyObj?.type)
    );
  };
  return (
    <CustomVehicleData>
      <Grid container spacing={2}>
        <Grid xs={12} className="imageSlider" item md={6}>
          <ImageGalleyV2
            vehicleData={vehicleData}
            productType={productType}
            productList={productList}
            handleThumbnailClick={handleThumbnailClick}
          />
        </Grid>
        <Grid xs={12} className="vehicleDataContainer" item md={6}>
          <MemoizedVehicleDetailsV2
            vehicleData={vehicleData}
            productType={productType}
          />
        </Grid>
      </Grid>
    </CustomVehicleData>
  );
};
export const MemoizedLeadCaptureMainV2 = React.memo(LeadCaptureMainV2);
